"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCognitiveServicesBingSpeechPonyfillFactory;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _BingSpeech = _interopRequireDefault(require("web-speech-cognitive-services/lib/BingSpeech"));

function injectReferenceGrammarID(_ref, referenceGrammarID) {
  var SpeechGrammarList = _ref.SpeechGrammarList,
      SpeechRecognition = _ref.SpeechRecognition;
  return (
    /*#__PURE__*/
    function (_SpeechRecognition) {
      (0, _inherits2.default)(_class, _SpeechRecognition);

      function _class() {
        (0, _classCallCheck2.default)(this, _class);
        return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(_class).apply(this, arguments));
      }

      (0, _createClass2.default)(_class, [{
        key: "start",
        value: function start() {
          this.grammars = new SpeechGrammarList();
          this.grammars.referenceGrammar = referenceGrammarID || '';
          return (0, _get2.default)((0, _getPrototypeOf2.default)(_class.prototype), "start", this).call(this);
        }
      }]);
      return _class;
    }(SpeechRecognition)
  );
}

function createCognitiveServicesBingSpeechPonyfillFactory(_x) {
  return _createCognitiveServicesBingSpeechPonyfillFactory.apply(this, arguments);
}

function _createCognitiveServicesBingSpeechPonyfillFactory() {
  _createCognitiveServicesBingSpeechPonyfillFactory = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(_ref2) {
    var authorizationToken, subscriptionKey, ponyfill, SpeechGrammarList, speechSynthesis, SpeechSynthesisUtterance;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            authorizationToken = _ref2.authorizationToken, subscriptionKey = _ref2.subscriptionKey;
            _context.next = 3;
            return (0, _BingSpeech.default)({
              authorizationToken: authorizationToken,
              subscriptionKey: subscriptionKey
            });

          case 3:
            ponyfill = _context.sent;
            SpeechGrammarList = ponyfill.SpeechGrammarList, speechSynthesis = ponyfill.speechSynthesis, SpeechSynthesisUtterance = ponyfill.SpeechSynthesisUtterance;
            return _context.abrupt("return", function (_ref3) {
              var referenceGrammarID = _ref3.referenceGrammarID;
              return {
                SpeechGrammarList: SpeechGrammarList,
                SpeechRecognition: injectReferenceGrammarID(ponyfill, referenceGrammarID),
                speechSynthesis: speechSynthesis,
                SpeechSynthesisUtterance: SpeechSynthesisUtterance
              };
            });

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createCognitiveServicesBingSpeechPonyfillFactory.apply(this, arguments);
}